import { render, staticRenderFns } from "./ProductSetItemDetails.vue?vue&type=template&id=677fafcb"
import script from "./ProductSetItemDetails.vue?vue&type=script&lang=js"
export * from "./ProductSetItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports